import React from 'react';
import { SlidePage } from '../index';
import chileCorner from '../imgs/marca_chile_corner.png';
import VocationLogo from '../imgs/vocation_start_logo.png';
// import EdumetricsLogo from '../imgs/edumetrics_logo_color_sm.png';
import EdumetricsIcono from '../imgs/edu_icon.png';
import EdumetricsLogoWhite from '../imgs/edumetrics_logo_blanco_sm.png';
import Icon02 from '../imgs/icons/edu_iconos_2.svg';
import Icon03 from '../imgs/icons/edu_iconos_3.svg';
import Icon05 from '../imgs/icons/edu_iconos_5.svg';
import Icon07 from '../imgs/icons/edu_iconos_7.svg';

const VocationTopPage = ({ user, background, campaign, ...rest }) => {
  const hasDisplayName = user.lastname || user.name;
  const displayName = `${user.lastname}, ${user.name}`;

  const hasLogo = campaign?.metadata?.logo ? campaign.metadata.logo : null;
  return (
    <SlidePage background={background} {...rest}>
      <div
        style={{
          position: 'absolute',
          // bottom: 464,
          top: 285,
          left: -32
          // width: '100%'
          // display: 'flex',
          // justifyContent: 'center'
        }}
      >
        <img
          src={Icon02}
          alt='edumetrics vocation start logo'
          style={{
            width: 125,
            height: '100%',
            display: 'block',
            objectFit: 'contain'
          }}
        />
      </div>

      <div
        style={{
          position: 'absolute',
          // bottom: 464,
          top: 225,
          right: -44
          // width: '100%'
          // display: 'flex',
          // justifyContent: 'center'
        }}
      >
        <img
          src={Icon05}
          alt='edumetrics vocation start logo'
          style={{
            width: 125,
            height: '100%',
            display: 'block',
            objectFit: 'contain'
          }}
        />
      </div>

      <div
        style={{
          position: 'absolute',
          // bottom: 464,
          top: 64,
          right: 160
          // width: '100%'
          // display: 'flex',
          // justifyContent: 'center'
        }}
      >
        <img
          src={Icon03}
          alt='edumetrics vocation start logo'
          style={{
            width: 150,
            height: '100%',
            display: 'block',
            objectFit: 'contain'
          }}
        />
      </div>

      <div
        style={{
          position: 'absolute',
          // bottom: 464,
          top: 52,
          left: 92
          // width: '100%'
          // display: 'flex',
          // justifyContent: 'center'
        }}
      >
        <img
          src={Icon07}
          alt='edumetrics vocation start logo'
          style={{
            width: 150,
            height: '100%',
            display: 'block',
            objectFit: 'contain'
          }}
        />
      </div>

      <div
        style={{
          position: 'absolute',
          top: 0,
          right: 0,
          width: 'auto',
          height: 185
        }}
      >
        <img
          src={chileCorner}
          alt='marca chile pestaña'
          style={{
            width: 'auto',
            height: 'inherit'
          }}
        />
      </div>

      <div
        style={{
          position: 'absolute',
          // bottom: 464,
          top: 16,
          left: 32
          // width: '100%'
          // display: 'flex',
          // justifyContent: 'center'
        }}
      >
        <img
          src={EdumetricsLogoWhite}
          alt='edumetrics logo'
          style={{
            width: 200,
            height: '100%',
            display: 'block',
            objectFit: 'contain'
          }}
        />
      </div>

      <div
        style={{
          background: '#FFFFFF',
          position: 'absolute',
          bottom: 0,
          height: 750,
          width: '100%'
        }}
      >
        <div style={{ position: 'relative', height: '100%', width: '100%' }}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              paddingTop: 48
            }}
          >
            <div style={{ position: 'relative', width: 200 }}>
              <div
                style={{
                  background: '#adb5bd',
                  height: 2,
                  width: 200,
                  position: 'absolute',
                  top: 16
                }}
              ></div>
              <div
                style={{
                  width: 200,
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  position: 'relative'
                }}
              >
                <div
                  style={{
                    height: 32,
                    width: 32,
                    background: '#f0c045',
                    borderRadius: '50%'
                  }}
                ></div>
                <div
                  style={{
                    height: 24,
                    width: 24,
                    background: '#adb5bd',
                    borderRadius: '50%'
                  }}
                ></div>
                <div
                  style={{
                    height: 24,
                    width: 24,
                    background: '#adb5bd',
                    borderRadius: '50%'
                  }}
                ></div>
              </div>
            </div>
          </div>
          <div
            style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              marginTop: 40
            }}
          >
            <img
              src={VocationLogo}
              alt='edumetrics vocation start logo'
              style={{
                width: 512,
                height: '100%',
                display: 'block',
                objectFit: 'contain'
              }}
            />
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              marginTop: 28,
              flexDirection: 'column'
            }}
          >
            <div style={{ fontWeight: 800, fontSize: '1.25rem' }}>
              {displayName}
            </div>
            <div style={{ marginTop: 8 }}>{user.RUT}</div>
            <div style={{ marginTop: 0 }}>{user.school}</div>
            <div style={{ marginTop: 0 }}>{user.grade}</div>
          </div>

          {hasLogo && (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginTop: 28
              }}
            >
              <img
                src={hasLogo}
                alt='edumetrics logo'
                style={{
                  width: '100%',
                  height: 100,
                  maxWidth: 200,
                  // height: '100%',
                  objectFit: 'contain'
                }}
              />
            </div>
          )}

          <div
            style={{
              position: 'absolute',
              // bottom: 464,
              bottom: 6,
              // left: 36,
              right: 16
              // width: '100%'
              // display: 'flex',
              // justifyContent: 'center'
            }}
          >
            <img
              src={EdumetricsIcono}
              alt='edumetrics logo'
              style={{
                width: 85,
                height: '100%',
                display: 'block',
                objectFit: 'contain'
              }}
            />
          </div>

          <div
            style={{
              position: 'absolute',
              // bottom: 464,
              bottom: 20,
              // right: 12,
              left: 36
              // width: '100%'
              // display: 'flex',
              // justifyContent: 'center'
            }}
          >
            <img
              src={`https://www.edumetrics.cl/api/qr?url=https://www.edumetrics.cl/report/${user?.responseId}?k=${user?.responseAccessKey}`}
              alt='qr code'
              style={{
                width: 100,
                height: 100,
                display: 'block'
              }}
            />
          </div>

          <div
            style={{
              position: 'absolute',
              bottom: 20,
              left: 0,
              right: 0,
              width: '100%',
              display: 'flex',
              justifyContent: 'center'
            }}
          >
            <span style={{ fontSize: 12, color: '#6c757d' }}>
              {user.responseId}
            </span>
          </div>
        </div>
      </div>
    </SlidePage>
  );
};

export default VocationTopPage;
